import React, { useState } from "react";
import EditCaregiver from "../../library/EditCaregiver/EditCaregiver";
import {
  editCaregiverReducer,
  mapDispatchToProps,
} from "./EditCaregiver.store";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { connect } from "react-redux";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";
import { attachReducer } from "@redux-dynostore/redux-subspace";

export const SmartEditCaregiver = (props) => {
  const { editCaregiver, onClose, caregiver } = props;

  const [error, setError] = useState(null);
  const [alertMessage, setAlertMessage] = useState("");

  const onSubmit = (formData) => {
    editCaregiver(formData)
      .then((obj) => {
        setError(null);
        sendNotification(obj.message, ToastType.SUCCESS);
        onClose(obj);
      })
      .catch((errorMessage) => {
        setError(!!errorMessage);
        if (
          errorMessage &&
          errorMessage.startsWith("Participant already assigned")
        ) {
          setAlertMessage(errorMessage);
        } else {
          sendNotification(errorMessage, ToastType.ERROR);
        }
      });
  };

  const clearAlertMessage = () => {
    setAlertMessage("");
    setError(false);
  };

  return (
    <EditCaregiver
      {...{ onSubmit }}
      {...{ caregiver }}
      {...{ alertMessage }}
      {...{ clearAlertMessage }}
      hasError={error}
    />
  );
};

export default dynamic(
  "EditCaregiverReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(editCaregiverReducer)
)(connect(null, mapDispatchToProps)(SmartEditCaregiver));
